export default __webpack_public_path__ + "static/media/pope_worldwide_fr.a6d91b66.svg";